export default __webpack_public_path__ + "static/media/Mikhael.4f129485.png";